export default "__VITE_ASSET__CD_98IGT__"